<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="callout callout-info">
                    <h5>
                        <button
                            v-if="
                                this.ClientData.BCP_ID == null &&
                                    this.ClientData.Verify_at != null
                            "
                            class="btn btn-success"
                            @click="BCPAdd()"
                        >
                            Add BCP
                        </button>
                        <button
                            v-if="!this.ClientData.Overall_Case_Status"
                            class="btn btn-success"
                            @click="AddOverAllCaseStatus()"
                        >
                            Add Overall Case Status
                        </button>
                    </h5>
                    <button
                        class="btn btn-danger"
                        :disabled="isPrinting"
                        @click="PrintData"
                    >
                        <span v-if="!isPrinting">
                            <i class="fas fa-file-alt"></i> PDF
                        </span>
                        <span v-else>
                            <i class="fas fa-spinner fa-spin"></i> Generating...
                        </span>
                    </button>
                </div>
                <div class="callout callout-info bold">
                    <h5>Company Name:- {{ this.ClientData.Company_Name }}</h5>
                </div>
                <div class="callout callout-info">
                    <h5>
                        Applicant Name:- {{ this.ClientData.Applicant_Name
                        }}<span class="float-md-right"
                            >Login Id:- {{ this.ClientData.Login_Id }}</span
                        >
                    </h5>
                </div>
                <div class="callout callout-info">
                    <h5>
                        Admin:- {{ this.ClientData.name }}
                        <span class="float-md-right"
                            >Location Type:-
                            {{ this.ClientData.Location_Type }}</span
                        >
                    </h5>
                </div>
                <!-- Main content -->
                <div class="invoice p-3 mb-3">
                    <!-- title row -->
                    <div class="row">
                        <div class="col-12">
                            <h4>
                                Bank Name:- {{ this.ClientData.Bank_Name }} Bank
                                Code:- {{ this.ClientData.Bank_Branch_Code }}
                                <small class="float-right"
                                    >Loan Amount:-
                                    {{
                                        currencyFormate(
                                            this.ClientData.Loan_Amount
                                        )
                                    }}</small
                                >
                            </h4>
                        </div>
                        <div class="col-12">
                            <h4>
                                Product Name:-
                                {{ this.ClientData.Product_Name }}
                            </h4>
                        </div>
                        <div class="col-12">
                            <h6>
                                Location :-
                                {{ this.ClientData.Location }}
                            </h6>
                        </div>
                        <div class="col-12">
                            <h6>
                                FI Bank Location :-
                                {{ this.ClientData.Fi_Bank_Location }}
                            </h6>
                        </div>
                        <div class="col-12">
                            <h6>
                                Office Name :-
                                {{ this.ClientData.Office_Name }}
                            </h6>
                        </div>
                        <!-- /.col -->
                    </div>
                    <!-- info row -->
                    <div class="row invoice-info">
                        <div
                            class="col-sm-4 invoice-col"
                            v-if="this.ClientData.Location_Type == 'RV'"
                        >
                            <address>
                                <strong>Residential Address</strong><br />
                                <span
                                    v-if="this.ClientData.Residential_Address"
                                >
                                    {{ this.ClientData.Residential_Address }}
                                </span>
                                <span v-else>NULL</span><br />
                                Contact Mobile:-<span
                                    v-if="
                                        this.ClientData
                                            .Contact_Person_Mobile_Number
                                    "
                                    >{{
                                        this.ClientData
                                            .Contact_Person_Mobile_Number
                                    }}</span
                                ><span v-else>NULL</span>
                            </address>
                        </div>
                        <!-- /.col -->
                        <div
                            class="col-sm-4 invoice-col"
                            v-if="this.ClientData.Location_Type == 'BV'"
                        >
                            <address>
                                <strong>Business Address</strong><br />
                                <span v-if="this.ClientData.Office_Address">
                                    {{ this.ClientData.Office_Address }}
                                </span>
                                <span v-else>NULL</span><br />
                                Phone:-<span
                                    v-if="this.ClientData.Office_Mobile_Number"
                                    >{{ this.ClientData.Office_Mobile_Number }}
                                </span>
                                <span v-else>NULL</span>
                            </address>
                        </div>
                        <div class="col-sm-4 invoice-col">
                            <address>
                                <strong>Dates</strong><br />
                                Created:-
                                {{
                                    customDateFormatter(
                                        this.ClientData.created_at
                                    )
                                }}<br />
                                Allocated:-
                                {{
                                    customDateFormatter(
                                        this.ClientData.AssignDate
                                    )
                                }}<br />
                                Verified:-
                                {{
                                    customDateFormatter(
                                        this.ClientData.Verify_at
                                    )
                                }}
                            </address>
                        </div>
                        <!-- /.col -->
                    </div>
                    <!-- /.row -->
                </div>

                <!-- Main content -->
                <div class="invoice p-3 mb-3">
                    <div class="row">
                        <!-- accepted payments column -->
                        <div class="col-12">
                            <h4>
                                Verification Data
                                <button
                                    class="btn btn-primary float-right mb-2"
                                    @click="EditVerificationDataModel()"
                                >
                                    Edit
                                </button>
                            </h4>
                        </div>
                        <div
                            class="col-6"
                            v-if="
                                this.ClientData.Location_Type == 'RV' ||
                                    this.ClientData.Location_Type == 'BV'
                            "
                        >
                            <div class="table-responsive">
                                <table class="table">
                                    <tr>
                                        <th style="width: 50%">
                                            Contact Person Name
                                        </th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Contact_Person_Name
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Contact_Person_Name
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Status:</th>
                                        <td>
                                            <span v-if="this.ClientData.Status"
                                                >{{ this.ClientData.Status }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Relation</th>
                                        <td>
                                            <span
                                                v-if="this.ClientData.Relation"
                                                >{{ this.ClientData.Relation }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Address Reachable</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Address_Reachable
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Address_Reachable
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Locality Type:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Locality_Type
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Locality_Type
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Address Conform:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Address_Conform
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Address_Conform
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Location Address:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Location_Address
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Location_Address
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Remark:</th>
                                        <td>
                                            <span v-if="this.ClientData.Remark"
                                                >{{ this.ClientData.Remark }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div
                            class="col-6"
                            v-if="this.ClientData.Location_Type == 'RV'"
                        >
                            <div class="table-responsive">
                                <table class="table">
                                    <tr>
                                        <th>Number Of Family Member:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Number_Of_Family_Member
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Number_Of_Family_Member
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Earning Member:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Earning_Member
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Earning_Member
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Accommodation Type:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Accommodation_Type
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Accommodation_Type
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Resident Status:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Resident_Status
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Resident_Status
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Assets Seen:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    ClientData.Assets_Seen &&
                                                        ClientData.Assets_Seen
                                                            .length
                                                "
                                            >
                                                {{
                                                    Array.isArray(
                                                        ClientData.Assets_Seen
                                                    )
                                                        ? ClientData.Assets_Seen.join(
                                                              ", "
                                                          )
                                                        : ClientData.Assets_Seen
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            No Of years Staying At Current
                                            Address:
                                        </th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .No_Of_years_Staying_At_Current_Address
                                                "
                                                >{{
                                                    this.ClientData
                                                        .No_Of_years_Staying_At_Current_Address
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Furnished Level:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Furnished_Level
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Furnished_Level
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Vehicle Found In Place:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Vehicle_Found_In_Place
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Vehicle_Found_In_Place
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>If Address Not Reachable:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .address_not_reachable_reason
                                                "
                                                >{{
                                                    this.ClientData
                                                        .address_not_reachable_reason
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            If Address Not Reachable Reason:
                                        </th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .address_not_reachable_remark
                                                "
                                                >{{
                                                    this.ClientData
                                                        .address_not_reachable_remark
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <!-- /.col -->
                        <div
                            class="col-6"
                            v-if="this.ClientData.Location_Type == 'BV'"
                        >
                            <div class="table-responsive">
                                <table class="table">
                                    <tr>
                                        <th>Executive Type:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Employee_Type
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Employee_Type
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Busness Activity:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Busness_Activity
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Busness_Activity
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Construction Type:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Construction_Type
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Construction_Type
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Board Name:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData.Board_Name
                                                "
                                                >{{
                                                    this.ClientData.Board_Name
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Activity Type:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Activity_Type
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Activity_Type
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Type Of Unit:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData.Type_Of_Unit
                                                "
                                                >{{
                                                    this.ClientData.Type_Of_Unit
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Assets Seen:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    ClientData.Assets_Seen &&
                                                        ClientData.Assets_Seen
                                                            .length
                                                "
                                            >
                                                {{
                                                    Array.isArray(
                                                        ClientData.Assets_Seen
                                                    )
                                                        ? ClientData.Assets_Seen.join(
                                                              ", "
                                                          )
                                                        : ClientData.Assets_Seen
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Entry Allowed:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .entry_allowed
                                                "
                                                >{{
                                                    this.ClientData
                                                        .entry_allowed
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Office Setup Seen:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .Office_Setup_Seen
                                                "
                                                >{{
                                                    this.ClientData
                                                        .Office_Setup_Seen
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Nature of Business:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .nature_of_business
                                                "
                                                >{{
                                                    this.ClientData
                                                        .nature_of_business
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr v-if="this.ClientData.Stock_Level">
                                        <th>Stock Level:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData.Stock_Level
                                                "
                                                >{{
                                                    this.ClientData.Stock_Level
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr
                                        v-if="
                                            this.ClientData
                                                .application_name_and_job_confirm
                                        "
                                    >
                                        <th>Application Name & Job Confirm:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .application_name_and_job_confirm
                                                "
                                                >{{
                                                    this.ClientData
                                                        .application_name_and_job_confirm
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr
                                        v-if="
                                            this.ClientData
                                                .no_of_years_doing_job
                                        "
                                    >
                                        <th>No. of Years Doing Job:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .no_of_years_doing_job
                                                "
                                                >{{
                                                    this.ClientData
                                                        .no_of_years_doing_job
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr
                                        v-if="
                                            this.ClientData
                                                .no_of_years_doing_business !=
                                                null
                                        "
                                    >
                                        <th>No. of Years Running Business:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .no_of_years_doing_business
                                                "
                                                >{{
                                                    this.ClientData
                                                        .no_of_years_doing_business
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr v-if="this.ClientData.designation">
                                        <th>Designation:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData.designation
                                                "
                                                >{{
                                                    this.ClientData.designation
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr v-if="this.ClientData.no_of_staff_seen">
                                        <th>No. of Staff Seen:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .no_of_staff_seen
                                                "
                                                >{{
                                                    this.ClientData
                                                        .no_of_staff_seen
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>If Address Not Reachable:</th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .address_not_reachable_reason
                                                "
                                                >{{
                                                    this.ClientData
                                                        .address_not_reachable_reason
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            If Address Not Reachable Reason:
                                        </th>
                                        <td>
                                            <span
                                                v-if="
                                                    this.ClientData
                                                        .address_not_reachable_remark
                                                "
                                                >{{
                                                    this.ClientData
                                                        .address_not_reachable_remark
                                                }}
                                            </span>
                                            <span v-else>NULL</span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <!-- /.col -->
                    </div>
                    <!-- /.row -->
                </div>
                <!-- /.invoice -->
            </div>
            <!-- /.col -->
        </div>
        <!-- /.row -->
        <div class="invoice p-3 mb-3">
            <div class="col-12">
                <h4>
                    Over All Case Status
                    <button
                        class="btn btn-primary float-right"
                        @click="EditOcerallCaseData()"
                    >
                        Edit
                    </button>
                </h4>
            </div>
            <div class="card-body table-responsive p-0">
                <div class="row">
                    <div class="col-10">
                        <div class="table-responsive">
                            <table class="table">
                                <tr>
                                    <th>Over All Case Status:</th>
                                    <td>
                                        <span
                                            v-if="
                                                this.ClientData
                                                    .Overall_Case_Status
                                            "
                                            >{{
                                                this.ClientData
                                                    .Overall_Case_Status
                                            }}
                                        </span>
                                        <span v-else>NULL</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Remarks:</th>
                                    <td>
                                        <span v-if="this.ClientData.Remark1"
                                            >{{ this.ClientData.Remark1 }}
                                        </span>
                                        <span v-else>NULL</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.row -->
        </div>
        <!-- Main content -->
        <div class="invoice p-3 mb-3">
            <div class="col-12">
                <h4>
                    Neighbor Data
                    <button
                        class="btn btn-primary float-right"
                        @click="EditNeighborDataModel()"
                    >
                        Edit
                    </button>
                </h4>
            </div>
            <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                    <tr>
                        <th>Name</th>
                        <th>Remarks</th>
                    </tr>
                    <tr
                        v-for="neighborDatas in NeighborData"
                        :key="neighborDatas.NEIGHBOR_ID"
                    >
                        <td>{{ neighborDatas.Neighbor_Name }}</td>
                        <td>{{ neighborDatas.Remark }}</td>
                    </tr>
                </table>
            </div>
            <!-- /.row -->
        </div>

        <!-- Main content -->

        <!-- <div class="invoice p-3 mb-3">
                <div class="col-12">
                  <h4>Photos Data</h4>
                </div>
              <div class="card-body table-responsive p-0">
                                <div class="filtr-item col-sm-2" data-category="1" data-sort="white sample">
                                <a data-toggle="lightbox" data-title="sample 1 - white">
                                    <img :src="'/image/'+ photosdatas.Photo_Name"/>
                                </a>
                                </div>
                    </div>
              <!-- /.row -->
        <!-- </div> -->

        <!-- Main content -->
        <div v-if="this.ClientData.BCP_ID != null" class="invoice p-3 mb-3">
            <div class="row">
                <!-- accepted payments column -->
                <div class="col-12">
                    <h4>BCP Data</h4>
                </div>
                <div class="col-6">
                    <div class="table-responsive">
                        <table class="table">
                            <tr>
                                <th>Contacted</th>
                                <td>
                                    <span v-if="this.ClientData.Contacted"
                                        >{{ this.ClientData.Contacted }}
                                    </span>
                                    <span v-else>NULL</span>
                                </td>
                            </tr>
                            <tr>
                                <th>Visit Date Time</th>
                                <td>
                                    <span v-if="this.ClientData.Visit_Date_Time"
                                        >{{ this.ClientData.Visit_Date_Time }}
                                    </span>
                                    <span v-else>NULL</span>
                                </td>
                            </tr>
                            <tr>
                                <th>Contact Person</th>
                                <td>
                                    <span v-if="this.ClientData.Contact_Person"
                                        >{{ this.ClientData.Contact_Person }}
                                    </span>
                                    <span v-else>NULL</span>
                                </td>
                            </tr>
                            <tr>
                                <th>Door Lock</th>
                                <td>
                                    <span v-if="this.ClientData.Door_Lock"
                                        >{{ this.ClientData.Door_Lock }}
                                    </span>
                                    <span v-else>NULL</span>
                                </td>
                            </tr>
                            <tr>
                                <th>Executive Behavior</th>
                                <td>
                                    <span
                                        v-if="
                                            this.ClientData.Executive_Behavior
                                        "
                                        >{{
                                            this.ClientData.Executive_Behavior
                                        }}
                                    </span>
                                    <span v-else>NULL</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <!-- /.col -->
                <div class="col-6">
                    <div class="table-responsive">
                        <table class="table">
                            <tr>
                                <th>Executive Asked For Money:</th>
                                <td>
                                    <span
                                        v-if="
                                            this.ClientData
                                                .Executive_Asked_For_Money
                                        "
                                        >{{
                                            this.ClientData
                                                .Executive_Asked_For_Money
                                        }}
                                    </span>
                                    <span v-else>NULL</span>
                                </td>
                            </tr>
                            <tr>
                                <th>Photo Match:</th>
                                <td>
                                    <span v-if="this.ClientData.Photo_Match"
                                        >{{ this.ClientData.Photo_Match }}
                                    </span>
                                    <span v-else>NULL</span>
                                </td>
                            </tr>
                            <tr>
                                <th>Not Contact Reason:</th>
                                <td>
                                    <span
                                        v-if="
                                            this.ClientData.Not_Contact_Reason
                                        "
                                        >{{
                                            this.ClientData.Not_Contact_Reason
                                        }}
                                    </span>
                                    <span v-else>NULL</span>
                                </td>
                            </tr>
                            <tr>
                                <th>Overall Case Result:</th>
                                <td>
                                    <span
                                        v-if="
                                            this.ClientData.Overall_Case_Result
                                        "
                                        >{{
                                            this.ClientData.Overall_Case_Result
                                        }}
                                    </span>
                                    <span v-else>NULL</span>
                                </td>
                            </tr>
                            <tr>
                                <th>Remarks:</th>
                                <td>
                                    <span v-if="this.ClientData.Remarks"
                                        >{{ this.ClientData.Remarks }}
                                    </span>
                                    <span v-else>NULL</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <!-- /.col -->
            </div>
            <!-- /.row -->
        </div>

        <!-- photos -->
        <div v-if="this.PhotosData.length" class="invoice p-3 mb-3">
            <div class="col">
                <div class="col-12">
                    <h4>photos</h4>
                </div>
                <table class="table table-hover">
                    <tr>
                        <th>Longitude * Latitude</th>
                        <th>Map Link</th>
                        <th>Photo</th>
                    </tr>
                    <tr
                        v-for="photosdatas in PhotosData"
                        :key="photosdatas.NEIGHBOR_ID"
                    >
                        <td>
                            {{ photosdatas.Longitud }} *
                            {{ photosdatas.Latitud }}
                        </td>
                        <td>
                            <a
                                :href="
                                    'https://www.google.com/maps?q=' +
                                        photosdatas.Latitud +
                                        ',' +
                                        photosdatas.Longitud
                                "
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                View on Map
                            </a>
                        </td>
                        <td>
                            <img
                                :src="'image/' + photosdatas.Photo_Name"
                                alt="Photo"
                                width="300"
                                height="300"
                                style="object-fit: cover;"
                            />
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <!-- end photos -->

        <div class="invoice p-3 mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
                <h4 class="mb-0">{{ remarkTitle }}</h4>

                <button class="btn btn-sm btn-success" @click="copyRemark">
                    <i class="fas fa-copy"></i> Copy
                </button>
            </div>

            <textarea
                class="form-control text-uppercase"
                rows="8"
                v-model="autoRemark"
            ></textarea>
        </div>

        <!-- Modal -->
        <div
            class="modal fade"
            id="BCP_Model"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Add BCP
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form
                        @submit.prevent="CreateBCP()"
                        @keydown="form.onKeydown($event)"
                    >
                        <div class="modal-body">
                            <div class="form-group">
                                <label>Contacted</label>
                                <multiselect
                                    :allow-empty="false"
                                    v-model="form.Contacted"
                                    :options="Option_Contacted"
                                    :searchable="false"
                                    :close-on-select="true"
                                    :show-labels="false"
                                    @input="changeContacted"
                                    :class="{
                                        'is-invalid': form.errors.has(
                                            'Contacted'
                                        )
                                    }"
                                    placeholder="Pick a value"
                                >
                                </multiselect>
                                <has-error
                                    :form="form"
                                    field="Contacted"
                                ></has-error>
                            </div>
                            <div>
                                <has-error
                                    :form="form"
                                    field="Contacted"
                                ></has-error>
                            </div>
                            <div
                                v-if="
                                    this.form.Contacted == 'Yes' &&
                                        this.form.Contacted != ''
                                "
                            >
                                <div class="form-group">
                                    <label>Visit Date </label>
                                    <input
                                        type="date"
                                        v-model="form.Visit_Date_Time"
                                    />
                                    <has-error
                                        :form="form"
                                        field="Visit_Date_Time"
                                    ></has-error>
                                </div>
                                <div class="form-group">
                                    <label>Contact Person</label>
                                    <multiselect
                                        :allow-empty="false"
                                        v-model="form.Contact_Person"
                                        :options="Option_Contact_Person"
                                        :searchable="false"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        :class="{
                                            'is-invalid': form.errors.has(
                                                'Contact_Person'
                                            )
                                        }"
                                        placeholder="Pick a value"
                                    >
                                    </multiselect>
                                    <has-error
                                        :form="form"
                                        field="Contact_Person"
                                    ></has-error>
                                </div>
                                <div class="form-group">
                                    <label>Door Lock</label>
                                    <multiselect
                                        :allow-empty="false"
                                        v-model="form.Door_Lock"
                                        :options="Option_Door_Lock"
                                        :searchable="false"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        :class="{
                                            'is-invalid': form.errors.has(
                                                'Door_Lock'
                                            )
                                        }"
                                        placeholder="Pick a value"
                                    >
                                    </multiselect>
                                    <has-error
                                        :form="form"
                                        field="Door_Lock"
                                    ></has-error>
                                </div>
                                <div class="form-group">
                                    <label>Executive Behavior</label>
                                    <multiselect
                                        :allow-empty="false"
                                        v-model="form.Executive_Behavior"
                                        :options="Option_Executive_Behavior"
                                        :searchable="false"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        :class="{
                                            'is-invalid': form.errors.has(
                                                'Executive_Behavior'
                                            )
                                        }"
                                        placeholder="Pick a value"
                                    >
                                    </multiselect>
                                    <has-error
                                        :form="form"
                                        field="Executive_Behavior"
                                    ></has-error>
                                </div>
                                <div class="form-group">
                                    <label>Executive Asked For Money</label>
                                    <multiselect
                                        :allow-empty="false"
                                        v-model="form.Executive_Asked_For_Money"
                                        :options="
                                            Option_Executive_Asked_For_Money
                                        "
                                        :searchable="false"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        :class="{
                                            'is-invalid': form.errors.has(
                                                'Executive_Asked_For_Money'
                                            )
                                        }"
                                        placeholder="Pick a value"
                                    >
                                    </multiselect>
                                    <has-error
                                        :form="form"
                                        field="Executive_Asked_For_Money"
                                    ></has-error>
                                </div>
                                <div class="form-group">
                                    <label>Photo Match</label>
                                    <multiselect
                                        :allow-empty="false"
                                        v-model="form.Photo_Match"
                                        :options="Option_Photo_Match"
                                        :searchable="false"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        :class="{
                                            'is-invalid': form.errors.has(
                                                'Photo_Match'
                                            )
                                        }"
                                        placeholder="Pick a value"
                                    >
                                    </multiselect>
                                    <has-error
                                        :form="form"
                                        field="Photo_Match"
                                    ></has-error>
                                </div>
                            </div>
                            <div
                                v-if="
                                    this.form.Contacted != 'Yes' &&
                                        this.form.Contacted != ''
                                "
                            >
                                <div class="form-group">
                                    <label>Not Contact Reason</label>
                                    <multiselect
                                        :allow-empty="false"
                                        v-model="form.Not_Contact_Reason"
                                        :options="Option_Not_Contact_Reason"
                                        :searchable="false"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        :class="{
                                            'is-invalid': form.errors.has(
                                                'Not_Contact_Reason'
                                            )
                                        }"
                                        placeholder="Pick a value"
                                    >
                                    </multiselect>
                                    <has-error
                                        :form="form"
                                        field="Not_Contact_Reason"
                                    ></has-error>
                                </div>
                            </div>
                            <div
                                v-if="
                                    this.form.Contacted == 'Yes' &&
                                        this.form.Contacted != ''
                                "
                            >
                                <div class="form-group">
                                    <label>Overall Case Result</label>
                                    <multiselect
                                        :allow-empty="false"
                                        v-model="form.Overall_Case_Result"
                                        :options="Option_Overall_Case_Result"
                                        :searchable="false"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        :class="{
                                            'is-invalid': form.errors.has(
                                                'Overall_Case_Result'
                                            )
                                        }"
                                        placeholder="Pick a value"
                                    >
                                    </multiselect>
                                    <has-error
                                        :form="form"
                                        field="Overall_Case_Result"
                                    ></has-error>
                                </div>
                            </div>
                            <div v-if="this.form.Contacted != ''">
                                <div class="form-group">
                                    <label>Remarks</label>
                                    <textarea
                                        v-model="form.Remarks"
                                        type="text"
                                        name="Remarks"
                                        class="form-control"
                                        :class="{
                                            'is-invalid': form.errors.has(
                                                'Remarks'
                                            )
                                        }"
                                    ></textarea>
                                    <has-error
                                        :form="form"
                                        field="Remarks"
                                    ></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-danger"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">
                                Save
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!--end Model-->
        <!-- Modal -->
        <div
            class="modal fade"
            id="AddOverAllCaseStatusModel"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5
                            class="modal-title"
                            v-show="!editmode"
                            id="exampleModalLabel"
                        >
                            Add Overall Case Result
                        </h5>
                        <h5
                            class="modal-title"
                            v-show="editmode"
                            id="exampleModalLabel"
                        >
                            Edit Overall Case Result
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form
                        @submit.prevent="CreateOverallcaseStatus()"
                        @keydown="form.onKeydown($event)"
                    >
                        <div class="modal-body">
                            <div class="form-group">
                                <label>Overall Case Result</label>
                                <multiselect
                                    :allow-empty="false"
                                    v-model="form.Overall_Case_Status"
                                    :options="Option_Overall_Case_Status"
                                    :searchable="false"
                                    :close-on-select="true"
                                    :show-labels="false"
                                    :class="{
                                        'is-invalid': form.errors.has(
                                            'Overall_Case_Result'
                                        )
                                    }"
                                    placeholder="Pick a value"
                                >
                                </multiselect>
                                <has-error
                                    :form="form"
                                    field="Overall_Case_Result"
                                ></has-error>
                            </div>
                            <div class="form-group">
                                <label>Remarks</label>
                                <textarea
                                    v-model="form.Remark1"
                                    type="text"
                                    name="Remark1"
                                    class="form-control"
                                    :class="{
                                        'is-invalid': form.errors.has('Remark1')
                                    }"
                                ></textarea>
                                <has-error
                                    :form="form"
                                    field="Remark1"
                                ></has-error>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-danger"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                v-show="!editmode"
                                class="btn btn-primary"
                            >
                                Save
                            </button>
                            <button
                                type="submit"
                                v-show="editmode"
                                class="btn btn-success"
                            >
                                Update
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!--end Model-->

        <!-- Modal -->
        <div
            class="modal fade"
            id="EditNeighborModel"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Neighbor Edit
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form
                        @submit.prevent="EditNeighborData()"
                        @keydown="form.onKeydown($event)"
                    >
                        <div class="modal-body">
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover">
                                    <tr>
                                        <th>Name</th>
                                        <th>Remarks</th>
                                    </tr>
                                    <tr
                                        v-for="neighborDatas1 in tempNeighborData1"
                                    >
                                        <td>
                                            <input
                                                type="text"
                                                v-model="
                                                    neighborDatas1.Neighbor_Name
                                                "
                                            />
                                        </td>
                                        <td>
                                            <multiselect
                                                :allow-empty="false"
                                                v-model="neighborDatas1.Remark"
                                                :options="
                                                    Option_Neighbor_Remarks
                                                "
                                                :searchable="false"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Pick a value"
                                            >
                                            </multiselect>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-danger"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                            <button type="submit" class="btn btn-success">
                                Update
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!--end Model-->

        <!-- Modal -->
        <div
            class="modal fade"
            id="EditVerificationDataModel"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Edit Verification
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form
                        @submit.prevent="EditVerificationData()"
                        @keydown="form.onKeydown($event)"
                    >
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-6">
                                    <div
                                        class="form-group"
                                        v-if="
                                            form1.Location_Type == 'RV' ||
                                                form1.Location_Type == 'BV'
                                        "
                                    >
                                        <label>Contact Person Name</label>
                                        <input
                                            v-model="form1.Contact_Person_Name"
                                            type="text"
                                            name="Contact_Person_Name"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'Contact_Person_Name'
                                                )
                                            }"
                                        />
                                        <has-error
                                            :form="form"
                                            field="Contact_Person_Name"
                                        ></has-error>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="
                                        form1.Location_Type == 'RV' ||
                                            form1.Location_Type == 'BV'
                                    "
                                >
                                    <div class="form-group">
                                        <label>Status</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Status"
                                            :options="Option_Status"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div
                                        class="form-group"
                                        v-if="
                                            form1.Location_Type == 'RV' ||
                                                form1.Location_Type == 'BV'
                                        "
                                    >
                                        <label>Relation</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Relation"
                                            :options="Option_Relation"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'RV'"
                                >
                                    <div class="form-group">
                                        <label>Vehicle Found In Place</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="
                                                form1.Vehicle_Found_In_Place
                                            "
                                            :options="
                                                Option_Vehicle_Found_In_Place
                                            "
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="
                                        form1.Location_Type == 'RV' ||
                                            form1.Location_Type == 'BV'
                                    "
                                >
                                    <div class="form-group">
                                        <label>Address Conform</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Address_Conform"
                                            :options="Option_Address_Conform"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Address Reachable</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Address_Reachable"
                                            :options="Option_Address_Reachable"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="
                                        form1.Location_Type == 'BV' &&
                                            form1.Address_Reachable == 'Yes'
                                    "
                                >
                                    <div class="form-group">
                                        <label>Entry Allowed</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.entry_allowed"
                                            :options="Option_Address_Conform"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="
                                        form1.Location_Type == 'RV' ||
                                            form1.Location_Type == 'BV'
                                    "
                                >
                                    <div class="form-group">
                                        <label>Locality Type</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Locality_Type"
                                            :options="Option_Locality_Type"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="
                                        form1.Location_Type == 'RV' ||
                                            form1.Location_Type == 'BV'
                                    "
                                >
                                    <div class="form-group">
                                        <label>Location Address</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Location_Address"
                                            :options="Option_Location_Address"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="
                                        form1.Location_Type == 'BV' &&
                                            form1.entry_allowed == 'Yes'
                                    "
                                >
                                    <div class="form-group">
                                        <label>Employee Type</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Employee_Type"
                                            :options="Option_Employee_Type"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'RV'"
                                >
                                    <div class="form-group">
                                        <label>Number Of Family Member</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="
                                                form1.Number_Of_Family_Member
                                            "
                                            :options="
                                                Option_Number_Of_Family_Member
                                            "
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'BV'"
                                >
                                    <div class="form-group">
                                        <label>Business Activity</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Busness_Activity"
                                            :options="Option_Busness_Activity"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'RV'"
                                >
                                    <div class="form-group">
                                        <label>Earning Member</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Earning_Member"
                                            :options="Option_Earning_Member"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'BV'"
                                >
                                    <div class="form-group">
                                        <label>Construction Type</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Construction_Type"
                                            :options="Option_Construction_Type"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'RV'"
                                >
                                    <div class="form-group">
                                        <label>Accommodation Type</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Accommodation_Type"
                                            :options="Option_Accommodation_Type"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'BV'"
                                >
                                    <div class="form-group">
                                        <label>Board Name</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Board_Name"
                                            :options="Option_Board_Name"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'RV'"
                                >
                                    <div class="form-group">
                                        <label>Resident Status</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Resident_Status"
                                            :options="Option_Resident_Status"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'BV'"
                                >
                                    <div class="form-group">
                                        <label>Activity Type</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Activity_Type"
                                            :options="Option_Activity_Type"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'RV'"
                                >
                                    <div class="form-group">
                                        <label>Assets Seen</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Assets_Seen"
                                            :multiple="true"
                                            :taggable="true"
                                            :preserve-search="true"
                                            :show-labels="false"
                                            :options="Option_Assets_RV"
                                            :searchable="false"
                                            :close-on-select="true"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                        <has-error
                                            :form="form"
                                            field="Assets_Seen"
                                        ></has-error>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="
                                        form1.Location_Type == 'BV' &&
                                            form1.entry_allowed == 'Yes'
                                    "
                                >
                                    <div class="form-group">
                                        <label>Assets Seen</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Assets_Seen"
                                            :multiple="true"
                                            :taggable="true"
                                            :preserve-search="true"
                                            :show-labels="false"
                                            :options="Option_Assets"
                                            :searchable="false"
                                            :close-on-select="true"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'BV'"
                                >
                                    <div class="form-group">
                                        <label>Type Of Unit</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Type_Of_Unit"
                                            :options="Option_Type_Of_Unit"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'RV'"
                                >
                                    <div class="form-group">
                                        <label
                                            >No Of years Staying At Current
                                            Address</label
                                        >
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="
                                                form1.No_Of_years_Staying_At_Current_Address
                                            "
                                            :options="
                                                Option_No_Of_years_Staying_At_Current_Address
                                            "
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'BV'"
                                >
                                    <div class="form-group">
                                        <label>Office Setup Seen</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Office_Setup_Seen"
                                            :options="Option_Office_Setup_Seen"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'RV'"
                                >
                                    <div class="form-group">
                                        <label>Furnished Level</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Furnished_Level"
                                            :options="Option_Furnished_Level"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'BV'"
                                >
                                    <div class="form-group">
                                        <label>Stock Level</label>
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="form1.Stock_Level"
                                            :options="Option_Stock_Level"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'BV'"
                                >
                                    <div class="form-group">
                                        <label
                                            >Application Name & Job
                                            Confirm</label
                                        >
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="
                                                form1.application_name_and_job_confirm
                                            "
                                            :options="Option_Address_Reachable"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="
                                        form1.Location_Type === 'BV' &&
                                            form1.Employee_Type === 'Salaried'
                                    "
                                >
                                    <div class="form-group">
                                        <label>No. of Years Doing Job</label>
                                        <input
                                            v-model="
                                                form1.no_of_years_doing_job
                                            "
                                            type="number"
                                            name="no_of_years_doing_job"
                                            class="form-control"
                                            min="0"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'no_of_years_doing_job'
                                                )
                                            }"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="
                                        form1.Location_Type === 'BV' &&
                                            form1.Employee_Type === 'Salaried'
                                    "
                                >
                                    <div class="form-group">
                                        <label>Designation</label>
                                        <input
                                            v-model="form1.designation"
                                            type="text"
                                            name="designation"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'designation'
                                                )
                                            }"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="
                                        form1.Location_Type === 'BV' &&
                                            form1.Employee_Type ===
                                                'Self Employed'
                                    "
                                >
                                    <div class="form-group">
                                        <label
                                            >No. of Years Running
                                            Business</label
                                        >
                                        <input
                                            v-model="
                                                form1.no_of_years_doing_business
                                            "
                                            type="number"
                                            min="0"
                                            name="no_of_years_doing_business"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'no_of_years_doing_business'
                                                )
                                            }"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="
                                        form1.Location_Type === 'BV' &&
                                            form1.Employee_Type ===
                                                'Self Employed'
                                    "
                                >
                                    <div class="form-group">
                                        <label>Nature of Business</label>
                                        <input
                                            v-model="form1.nature_of_business"
                                            type="text"
                                            name="nature_of_business"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'nature_of_business'
                                                )
                                            }"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="form1.Location_Type == 'BV'"
                                >
                                    <div class="form-group">
                                        <label>No. of Staff Seen</label>
                                        <input
                                            v-model="form1.no_of_staff_seen"
                                            type="number"
                                            min="0"
                                            name="no_of_staff_seen"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'no_of_staff_seen'
                                                )
                                            }"
                                        />
                                    </div>
                                </div>
                                <div
                                    class="col-6"
                                    v-if="
                                        form1.Location_Type == 'BV' &&
                                            form1.Address_Reachable == 'No'
                                    "
                                >
                                    <div class="form-group">
                                        <label
                                            >If Address Not Reachable
                                            Reason</label
                                        >
                                        <multiselect
                                            :allow-empty="false"
                                            v-model="
                                                form1.address_not_reachable_reason
                                            "
                                            :options="Option_Reason"
                                            :searchable="false"
                                            :close-on-select="true"
                                            :show-labels="false"
                                            placeholder="Pick a value"
                                        >
                                        </multiselect>
                                    </div>
                                </div>
                                <div
                                    class="col-12"
                                    v-if="
                                        form1.Location_Type == 'BV' &&
                                            form1.Address_Reachable == 'No'
                                    "
                                >
                                    <div class="form-group">
                                        <label>Remarks</label>
                                        <textarea
                                            v-model="
                                                form1.address_not_reachable_remark
                                            "
                                            type="text"
                                            name="address_not_reachable_remark"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'address_not_reachable_remark'
                                                )
                                            }"
                                        ></textarea>
                                        <has-error
                                            :form="form"
                                            field="address_not_reachable_remark"
                                        ></has-error>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Remarks</label>
                                        <textarea
                                            v-model="form1.Remark"
                                            type="text"
                                            name="Remark"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'Remark'
                                                )
                                            }"
                                        ></textarea>
                                        <has-error
                                            :form="form"
                                            field="Remark"
                                        ></has-error>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-danger"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                            <button type="submit" class="btn btn-success">
                                Update
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!--end Model-->
    </div>
    <!-- /.container-fluid -->
</template>

<script>
import Toastselectedlet from "../widget/toast";
import moment from "moment";
export default {
    components: { Multiselect, Toastselectedlet },
    data() {
        console.log(this.$route.params.ClientInfo);
        return {
            toast: new Vue(),
            editmode: false,
            ClientData: this.$route.params.ClientInfo,
            autoRemark: "",
            remarkTitle: "",
            NeighborData: {},
            tempNeighborData1: {},
            PhotosData: {},
            isPrinting: false,
            tempdata: [],
            Option_Contacted: ["Yes", "No"],
            Option_Assets_RV: ["TV", "Refrigerator", "Furniture", "AC"],
            Option_Assets: ["Computer/Laptop", "AC", "Chair", "Table"],
            Option_Contact_Person: [
                "Self",
                "Wife",
                "Brother",
                "Sister",
                "Cousin",
                "Uncle",
                "Auntie",
                "Husband",
                "Neighbor"
            ],
            Option_Door_Lock: ["Yes", "No"],
            Option_Executive_Behavior: ["Good", "Fair", "Bad"],
            Option_Executive_Asked_For_Money: ["Yes", "No"],
            Option_Photo_Match: ["Yes", "No"],
            Option_Not_Contact_Reason: ["Ringing", "SwitchedOff", "Refused"],
            Option_Overall_Case_Result: ["Ok", "NotOk"],
            Option_Overall_Case_Status: [
                "Positive",
                "Negative",
                "Refer to Bank"
            ],
            Option_Neighbor_Remarks: ["POSITIVE", "NEGATIVE"],

            Option_Status: [
                "Pending",
                "Approve",
                "Reject",
                "Reallocation",
                "DoorClose",
                "AddressNotFound",
                "ApplicantShifted",
                "LoanCancle",
                "WrongOrImcompleteAddress",
                "ApplicantLeftJob",
                "EntryRestricted"
            ],
            Option_Relation: [
                "Self",
                "Wife",
                "Brother",
                "Sister",
                "Cousin",
                "Uncle",
                "Auntie",
                "Husband",
                "Neighbor",
                "Other"
            ],
            Option_Address_Conform: ["Yes", "No"],
            Option_Locality_Type: [
                "Commercial",
                "Residential",
                "High",
                "Middle",
                "Low"
            ],
            Option_Location_Address: ["Easy", "Hard", "Medium", "Difficult"],
            Option_Employee_Type: ["Salaried", "Self Employed"],
            Option_Number_Of_Family_Member: [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10"
            ],
            Option_Busness_Activity: ["High", "Medium", "Low", "None"],
            Option_Earning_Member: [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10"
            ],
            Option_Construction_Type: [
                "Rented",
                "Temporary Shade",
                "Permanent",
                "Under Construction"
            ],
            Option_Accommodation_Type: [
                "Bungalow",
                "Chawl",
                "Flat",
                "Independent House",
                "Semi Pukka",
                "Temporary Setup"
            ],
            Option_Board_Name: [
                "Name Board Seen",
                "No Name Board Seen",
                "Name Board Differ"
            ],
            Option_Resident_Status: [
                "Rented",
                "Owned",
                "Parental Owned",
                "Bachelor",
                "Under Construction",
                "Company Provided",
                "Relatives Owned"
            ],
            Option_Activity_Type: ["Manufacturing", "Service", "Trading"],
            Option_Type_Of_Unit: ["Commercial Complex", "Industrial Area"],
            Option_No_Of_years_Staying_At_Current_Address: [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12",
                "13",
                "14",
                "15",
                "16",
                "17",
                "18",
                "19",
                "20",
                "21",
                "22",
                "23",
                "24",
                "25",
                "26",
                "27",
                "28",
                "29",
                "30"
            ],
            Option_Office_Setup_Seen: ["Yes", "No"],
            Option_Furnished_Level: ["High", "Medium", "Low"],
            Option_Stock_Level: ["High", "Medium", "Low", "None"],
            Option_Address_Reachable: ["Yes", "No"],
            Option_Reason: ["Unable to Locate", "Incomplete Address"],
            Option_Vehicle_Found_In_Place: [
                "Two Wheeler",
                "Three Wheeler",
                "Four Wheeler"
            ],

            form1: new Form({
                VERIFICATION_ID_REF: "",
                Contact_Person_Name: "",
                Status: "",
                Relation: "",
                Vehicle_Found_In_Place: "",
                Address_Conform: "",
                Locality_Type: "",
                Location_Type: "",
                Location_Address: "",
                entry_allowed: "",
                Employee_Type: "",
                Number_Of_Family_Member: "",
                Busness_Activity: "",
                Earning_Member: "",
                Construction_Type: "",
                Accommodation_Type: "",
                Board_Name: "",
                Resident_Status: "",
                Activity_Type: "",
                Assets_Seen: "",
                Type_Of_Unit: "",
                No_Of_years_Staying_At_Current_Address: "",
                Office_Setup_Seen: "",
                Furnished_Level: "",
                Stock_Level: "",
                Address_Reachable: "",
                application_name_and_job_confirm: "",
                no_of_years_doing_job: "",
                no_of_years_doing_business: "",
                designation: "",
                nature_of_business: "",
                no_of_staff_seen: "",
                address_not_reachable_reason: "",
                address_not_reachable_remark: "",
                Remark: ""
            }),

            form: new Form({
                BCP_ID: "",
                VERIFICATION_ID_REF: this.$route.params.ClientInfo
                    .VERIFICATION_ID_REF,
                Contacted: "",
                Visit_Date_Time: "",
                Contact_Person: "",
                Door_Lock: "",
                Executive_Behavior: "",
                Executive_Asked_For_Money: "",
                Photo_Match: "",
                Not_Contact_Reason: "",
                Overall_Case_Result: "",
                Remarks: "",
                Overall_Case_Status: "",
                Remark1: ""
            })
        };
    },

    created() {
        if (
            this.$route.params.ClientInfo == undefined ||
            this.$route.params.ClientInfo == null
        ) {
            this.$router.push({
                name: "OverAllCaseClientList"
            });
        }
    },
    mounted() {
        this.onLoadPhoto();
        this.onLoadNeighbor();
    },
    methods: {
        changeContacted() {
            (this.form.Visit_Date_Time = ""),
                (this.form.Contact_Person = ""),
                (this.form.Door_Lock = ""),
                (this.form.Executive_Behavior = ""),
                (this.form.Executive_Asked_For_Money = ""),
                (this.form.Photo_Match = ""),
                (this.form.Not_Contact_Reason = ""),
                (this.form.Overall_Case_Result = ""),
                (this.form.Remark = "");
        },
        getAnimalByIndex({ animals = [], index = 0 }) {
            return animals[index] || {};
        },
        generateRemark() {
            if (!this.PhotosData) return;

            const photo = Array.isArray(this.PhotosData)
                ? this.PhotosData[0]
                : this.PhotosData;

            if (!photo) return;

            const lat = photo.Latitud || "";
            const long = photo.Longitud || "";

            const visitDate = moment(this.ClientData.Verify_at).format(
                "DD/MM/YYYY"
            );
            const visitTime = moment(this.ClientData.Verify_at).format(
                "hh:mm A"
            );

            const assets = Array.isArray(this.ClientData.Assets_Seen)
                ? this.ClientData.Assets_Seen.join(", ")
                : this.ClientData.Assets_Seen;

            const locality = this.ClientData.Locality_Type || "";
            const addressType = this.ClientData.Accommodation_Type || "";
            const status = this.ClientData.Status || "";
            const Board_Name = this.ClientData.Board_Name;
            const Type_Of_Unit = this.ClientData.Type_Of_Unit;
            const no_of_staff_seen = this.ClientData.no_of_staff_seen;

            if (this.ClientData.Location_Type === "RV") {
                const neighbor =
                    this.NeighborData && this.NeighborData.length
                        ? this.NeighborData.map(n => n.Neighbor_Name)
                              .join(", ")
                              .replace(/,([^,]*)$/, " AND$1")
                        : "";
                this.remarkTitle = "RESIDENCE REMARK";
                this.autoRemark = `LAT ${lat} LONG ${long} AT THE TIME OF VISIT DATE ${visitDate} TIME ${visitTime} MET APPLICANT ${this
                    .ClientData.Relation || ""} ${this.ClientData
                    .Contact_Person_Name ||
                    ""} AT THE TIME OF VISIT FAMILY MEMBER ${
                    this.ClientData.Number_Of_Family_Member
                } AND EARNING MEMBER ${
                    this.ClientData.Earning_Member
                } APPLICANT STAYING SINCE LAST ${
                    this.ClientData.No_Of_years_Staying_At_Current_Address
                } YEARS AT GIVEN ADDRESS HOUSE IS ${
                    this.ClientData.Resident_Status
                } ${this.ClientData.Accommodation_Type} TYPE RESI IN ${
                    this.ClientData.Locality_Type
                } CLASS TYPE LOCALITY HAVE ${assets} SEEN AT RESI ${
                    this.ClientData.Location_Address
                } TO LOCATED ADDRESS APPLICANT NAME AND STAYING CONFIRMED THRUGH SECURITY PERSON AND NEIGHBOUR ${neighbor}. STATUS IS ${
                    this.ClientData.Status
                } ONLY ON BASED OF APPLICANT NAME AND STAYING CONFIRMED`;
                return;
            }

            if (
                this.ClientData.Location_Type === "BV" &&
                this.ClientData.Employee_Type === "Salaried"
            ) {
                this.remarkTitle = "SALARIED OFFICE REMARK";
                this.autoRemark = `LAT ${lat} LONG ${long} AT THE TIME OF VISIT DATE ${visitDate} TIME ${visitTime} MET STAFF PERSON ${this.ClientData.Contact_Person_Name} AT THE TIME OF VISIT APPLICANT IS DOING A JOB AS ${this.ClientData.designation} SINCE LAST ${this.ClientData.no_of_years_doing_job} YEARS AT GIVEN ADDRESS SALARY DETAILS NOT GIVEN OFFICE ${Board_Name} ${Type_Of_Unit} TYPE PUKKA OFFICE IN ${locality} AREA OFFICE IN ______ SQ FEEET CARPET AREA ${no_of_staff_seen} PERSON STAFF AND AC PC TABLE CHAIR STOCK ACTIVITY AVERAGE SEEN APPLICANT NAME AND JOB CONFIRMED THROUGH ______ STAFF PERSON AND SECURITY ______. STATUS IS POSITIVE ONLY ON BASED OF APPLICANT NAME AND JOB ${status} `;
                return;
            }

            if (
                this.ClientData.Location_Type === "BV" &&
                this.ClientData.Employee_Type === "Self Employed"
            ) {
                this.remarkTitle = "SELF EMPLOYED OFFICE REMARK";
                this.autoRemark = `LAT ${lat} LONG ${long} AT THE TIME OF VISIT DATE ${visitDate} TIME ${visitTime} MET STAFF PERSON ${this
                    .ClientData.Contact_Person_Name ||
                    ""} APPLICANT IS DOING BUSINESS OF ${this.ClientData
                    .nature_of_business || ""} SINCE LAST ${this.ClientData
                    .no_of_years_doing_business ||
                    ""} YEARS AT GIVEN ADDRESS INCOME DETAILS NOT GIVEN OFFICE NAME BOARD ${this
                    .ClientData.Board_Name || ""} ${this.ClientData
                    .Construction_Type || ""} OFFICE IN ${locality} AREA ${this
                    .ClientData.no_of_staff_seen ||
                    ""} PERSON STAFF AND ${assets ||
                    ""} SEEN BUSINESS PLACE IS ${this.ClientData
                    .Resident_Status ||
                    ""} APPLICANT NAME AND BUSINESS CONFIRMED STATUS IS ${status}`;
                return;
            }
            if (this.ClientData.Status === "DoorClose") {
                this.remarkTitle = "DOOR LOCK REMARK";
                const neighbor =
                    this.NeighborData && this.NeighborData.length
                        ? this.NeighborData.map(n => n.Neighbor_Name)
                              .join(", ")
                              .replace(/,([^,]*)$/, " AND$1")
                        : "";

                if (this.ClientData.Location_Type === "RV") {
                    this.autoRemark = `RESI LAT ${lat} LONG ${long} AT THE TIME OF VISIT DATE ${visitDate} TIME ${visitTime} AT THE TIME OF VISIT HOUSE IS DOOR LOCK ${this
                        .ClientData.Accommodation_Type ||
                        ""} TYPE RESI IN ${this.ClientData.Locality_Type ||
                        ""} CLASS TYPE LOCALITY ${this.ClientData
                        .Location_Address ||
                        ""} TO LOCATED ADDRESS APPLICANT NAME AND STAYING CONFIRMED THROUGH SECURITY PERSON AND NEIGHBOUR ${neighbor}. STATUS IS NEGATIVE DUE TO HOUSE DOOR LOCK.`;
                }

                if (this.ClientData.Location_Type === "BV") {
                    this.autoRemark = `OFFICE---LAT ${lat} LONG ${long} AT THE TIME OF VISIT DATE ${visitDate} TIME ${visitTime} AT THE TIME OF VISIT OFFICE IS DOOR LOCK ${this
                        .ClientData.Board_Name || ""} ${this.ClientData
                        .Construction_Type || ""} OFFICE IN ${this.ClientData
                        .Locality_Type || ""} AREA ${this.ClientData
                        .Location_Address ||
                        ""} TO LOCATED ADDRESS APPLICANT NAME AND BUSINESS CONFIRMED THROUGH SECURITY PERSON AND NEIGHBOUR ${neighbor}. STATUS IS NEGATIVE DUE TO OFFICE DOOR LOCK.`;
                }
                return;
            }
        },
        copyRemark() {
            if (!this.autoRemark) return;
            navigator.clipboard
                .writeText(this.autoRemark)
                .then(() => {
                    this.toast.$emit("LoadingOffSuccess", "Remark copied");
                })
                .catch(() => {
                    alert("Copy failed");
                });
        },
        onLoadNeighbor() {
            axios
                .get(
                    "neighborLoadForClientDetails/" +
                        this.form.VERIFICATION_ID_REF
                )
                .then(({ data }) => {
                    (this.NeighborData = data),
                        (this.ClientData.neighbors = this.NeighborData);
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        EditNeighborData() {
            axios
                .post("neighborDataEdit", { data: this.tempNeighborData1 })
                .then(({ data }) => {
                    (this.NeighborData = data),
                        (this.ClientData.neighbors = this.NeighborData);
                    $("#EditNeighborModel").modal("hide");
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        onLoadPhoto() {
            axios
                .get(
                    "photosLoadForClientDetails/" +
                        this.form.VERIFICATION_ID_REF
                )
                .then(({ data }) => {
                    (this.PhotosData = data),
                        (this.ClientData.photos = this.PhotosData),
                        this.generateRemark();
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        BCPAdd() {
            $("#BCP_Model").modal("show");
        },
        EditVerificationDataModel() {
            this.form1.reset();
            $("#EditVerificationDataModel").modal("show");
            this.form1.fill(this.ClientData);
        },
        EditVerificationData() {
            (this.form1.VERIFICATION_ID_REF = this.form.VERIFICATION_ID_REF),
                this.toast.$emit("LoadingOn");
            this.form1
                .post("editVerificationData")
                .then(data => {
                    $("#EditVerificationDataModel").modal("hide");
                    this.toast.$emit("LoadingOffSuccess", "Edit successfully");

                    (this.ClientData.VERIFICATION_ID_REF =
                        data.data.VERIFICATION_ID_REF),
                        (this.ClientData.Contact_Person_Name =
                            data.data.Contact_Person_Name),
                        (this.ClientData.Status = data.data.Status),
                        (this.ClientData.Relation = data.data.Relation),
                        (this.ClientData.Vehicle_Found_In_Place =
                            data.data.Vehicle_Found_In_Place),
                        (this.ClientData.Address_Conform =
                            data.data.Address_Conform),
                        (this.ClientData.Locality_Type =
                            data.data.Locality_Type),
                        (this.ClientData.Location_Address =
                            data.data.Location_Address),
                        (this.ClientData.entry_allowed =
                            data.data.entry_allowed),
                        (this.ClientData.Employee_Type =
                            data.data.Employee_Type),
                        (this.ClientData.Number_Of_Family_Member =
                            data.data.Number_Of_Family_Member),
                        (this.ClientData.Busness_Activity =
                            data.data.Busness_Activity),
                        (this.ClientData.Earning_Member =
                            data.data.Earning_Member),
                        (this.ClientData.Construction_Type =
                            data.data.Construction_Type),
                        (this.ClientData.Accommodation_Type =
                            data.data.Accommodation_Type),
                        (this.ClientData.Board_Name = data.data.Board_Name),
                        (this.ClientData.Resident_Status =
                            data.data.Resident_Status),
                        (this.ClientData.Activity_Type =
                            data.data.Activity_Type),
                        (this.ClientData.Assets_Seen = data.data.Assets_Seen),
                        (this.ClientData.Type_Of_Unit = data.data.Type_Of_Unit),
                        (this.ClientData.No_Of_years_Staying_At_Current_Address =
                            data.data.No_Of_years_Staying_At_Current_Address),
                        (this.ClientData.Office_Setup_Seen =
                            data.data.Office_Setup_Seen),
                        (this.ClientData.Furnished_Level =
                            data.data.Furnished_Level),
                        (this.ClientData.Stock_Level = data.data.Stock_Level),
                        (this.ClientData.Remark = data.data.Remark);
                    this.ClientData.Address_Reachable =
                        data.data.Address_Reachable;
                    this.ClientData.application_name_and_job_confirm =
                        data.data.application_name_and_job_confirm;
                    this.ClientData.no_of_years_doing_job =
                        data.data.no_of_years_doing_job;
                    this.ClientData.no_of_years_doing_business =
                        data.data.no_of_years_doing_business;
                    this.ClientData.designation = data.data.designation;
                    this.ClientData.nature_of_business =
                        data.data.nature_of_business;
                    this.ClientData.no_of_staff_seen =
                        data.data.no_of_staff_seen;
                    this.ClientData.address_not_reachable_reason =
                        data.data.address_not_reachable_reason;
                    this.ClientData.address_not_reachable_remark =
                        data.data.address_not_reachable_remark;
                })
                .catch(() => {
                    this.toast.$emit("LoadingOffError", "your Request Failed.");
                });
        },
        AddOverAllCaseStatus() {
            $("#AddOverAllCaseStatusModel").modal("show");
        },
        EditOcerallCaseData() {
            (this.editmode = true), this.form.reset();
            $("#AddOverAllCaseStatusModel").modal("show");
            this.form.fill(this.ClientData);
        },
        EditNeighborDataModel() {
            $("#EditNeighborModel").modal("show");
            this.tempNeighborData1 = _.cloneDeep(this.NeighborData);
        },
        CreateOverallcaseStatus() {
            this.toast.$emit("LoadingOn");
            this.form
                .post("createOverallcaseStatus")
                .then(data => {
                    $("#AddOverAllCaseStatusModel").modal("hide");
                    (this.form.Overall_Case_Status = ""),
                        (this.form.Remark1 = ""),
                        this.toast.$emit(
                            "LoadingOffSuccess",
                            "Status Added successfully"
                        );
                    (this.ClientData.Overall_Case_Status =
                        data.data.Overall_Case_Status),
                        (this.ClientData.Remark1 = data.data.Remark1);
                })
                .catch(() => {
                    this.toast.$emit("LoadingOffError", "your Request Failed.");
                });
        },
        async PrintData() {
            if (this.isPrinting) return;
            this.isPrinting = true;
            this.tempdata = [this.ClientData];
            this.toast.$emit("ProgressBarLoading");
            try {
                const response = await axios.post(
                    "/printsingleData",
                    { data: this.tempdata },
                    { responseType: "arraybuffer" }
                );

                const blob = new Blob([response.data], {
                    type: response.headers["content-type"]
                });
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                    "download",
                    `${this.ClientData.Login_Id}_${this.ClientData.Location_Type}.pdf`
                );
                document.body.appendChild(link);
                link.click();
                link.remove();

                this.toast.$emit("ProgressBarFinish");
            } catch (error) {
                this.toast.$emit(
                    "ProgressBarFailerror",
                    "Cannot generate PDF. Please try again."
                );
            } finally {
                this.isPrinting = false; // re-enable button
            }
        },
        CreateBCP() {
            this.toast.$emit("LoadingOn");
            this.form
                .post("bcp_master")
                .then(data => {
                    $("#BCP_Model").modal("hide");
                    this.toast.$emit(
                        "LoadingOffSuccess",
                        "BCP Create successfully"
                    );
                    (this.ClientData.BCP_ID = data.data.BCP_ID),
                        (this.ClientData.VERIFICATION_ID_REF =
                            data.data.VERIFICATION_ID_REF),
                        (this.ClientData.Contacted = data.data.Contacted),
                        (this.ClientData.Visit_Date_Time =
                            data.data.Visit_Date_Time),
                        (this.ClientData.Contact_Person =
                            data.data.Contact_Person),
                        (this.ClientData.Door_Lock = data.data.Door_Lock),
                        (this.ClientData.Executive_Behavior =
                            data.data.Executive_Behavior),
                        (this.ClientData.Executive_Asked_For_Money =
                            data.data.Executive_Asked_For_Money),
                        (this.ClientData.Photo_Match = data.data.Photo_Match),
                        (this.ClientData.Not_Contact_Reason =
                            data.data.Not_Contact_Reason),
                        (this.ClientData.Overall_Case_Result =
                            data.data.Overall_Case_Result),
                        (this.ClientData.Remarks = data.data.Remarks);
                })
                .catch(() => {
                    this.toast.$emit("LoadingOffError", "your Request Failed.");
                });
        }
    }
};
</script>
